import type { FormattedProductBundle } from 'reducers/detail/productDetail';
import type { SizeChartModalContent } from 'components/common/SizeChartModal';
import { track } from 'apis/amethyst';
import { evViewSizeChart } from 'events/product';
import { hasSizeChartAccordionSection } from 'helpers/ProductUtils';
import { SIZE_CHART_ACCORDION_HEADING } from 'constants/product';
import useMartyContext from 'hooks/useMartyContext';
import { Accordion } from 'components/common/Accordion';
import SizeCharts from 'components/productdetail/description/SizeCharts';

interface SizeChartAccordionProps {
  openSizeChartModal: (content: SizeChartModalContent) => void;
  productDetail?: FormattedProductBundle;
}

export const SizeChartAccordion = ({ productDetail, openSizeChartModal }: SizeChartAccordionProps) => {
  const {
    marketplace: {
      pdp: { showDescriptionSizeChart }
    }
  } = useMartyContext();

  const trackViewSizeChart = () => {
    track(() => [evViewSizeChart, {}]);
  };

  if (!productDetail) {
    return null;
  }

  const { defaultProductType, description } = productDetail;

  if (!defaultProductType || !description) {
    return null;
  }

  if (
    !hasSizeChartAccordionSection({
      defaultProductType,
      description,
      showDescriptionSizeChart
    })
  ) {
    return null;
  }

  return (
    <div data-test-id="sizeChartAccordion">
      <Accordion heading={SIZE_CHART_ACCORDION_HEADING}>
        <ul className="isolate">
          <SizeCharts
            descriptionItems={description}
            openSizeChartModal={openSizeChartModal}
            productType={defaultProductType}
            trackViewSizeChart={trackViewSizeChart}
          />
        </ul>
      </Accordion>
    </div>
  );
};
